var _jsxFileName = "/home/circleci/NACL/NACL/packages/nr-vamp-xl-copy-to-clipboard/src/CopyToClipboard.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { NikeStylesContext } from '@nike/nr-sole-xl-theme-provider';
import faPaste from '@fortawesome/fontawesome-free-solid/faPaste';
import CopyToClipboardPure from './CopyToClipboardPure';
import defaultStyles from './styles';

var CopyToClipboard = function CopyToClipboard(_ref) {
  var children = _ref.children,
      styleExtension = _ref.styleExtension,
      rest = _objectWithoutProperties(_ref, ["children", "styleExtension"]);

  return React.createElement(NikeStylesContext.Consumer, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9
    },
    __self: this
  }, function (_ref2) {
    var attributes = _ref2.attributes,
        mergeStyles = _ref2.mergeStyles,
        globalStyleExtension = _ref2.styleExtension;
    var styles = mergeStyles(attributes, defaultStyles, globalStyleExtension.CopyToClipboard, styleExtension);
    return React.createElement(CopyToClipboardPure, _extends({
      styles: styles
    }, rest, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 19
      },
      __self: this
    }), children);
  });
};

CopyToClipboard.propTypes = {
  /** Cut or copy directive for ClipboardJS. Cut is only possible on `input` or `textarea`. */
  action: PropTypes.oneOf(['copy', 'cut']),

  /** The cuttable/copyable content. */
  children: PropTypes.node,

  /** Specify DOM node id of element that should execute clipboard action (e.g., `#trigger`).
   *  Only necessary if you're using custom children with your own clip button. */
  clipTrigger: PropTypes.string,

  /** Unique id used for E2E testing and under the hood for ClipboardJS. */
  'data-e2e': PropTypes.string.isRequired,

  /** If `true`, clipboard events are disabled. */
  disabled: PropTypes.bool,

  /** Custom tooltip message shown for browsers that do not support copying to clipboard. */
  errorText: PropTypes.string,

  /** Any icon declaration understood by FontAwesome (e.g., `['fas', 'copy']`, `faCoffee`). */
  icon: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.element, PropTypes.object, PropTypes.string]),

  /** Custom node used to label to copyable text. */
  label: PropTypes.node,

  /** Callback function executed on button click. */
  onClick: PropTypes.func,

  /** Callback function that fires in unsupported browsers. `function(evt.action, evt.trigger) =>
   *  {}` */
  onError: PropTypes.func,

  /** Callback function fired after successful copy. `function(evt.action, evt.text, evt.trigger) =>
   *  {}` */
  onSuccess: PropTypes.func,

  /** Extends and overrides Nike MUI styles. */
  styleExtension: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    button: PropTypes.shape({}),
    buttonDisabled: PropTypes.shape({}),
    buttonWrapper: PropTypes.shape({}),
    clipContent: PropTypes.shape({}),
    icon: PropTypes.shape({}),
    iconDisabled: PropTypes.shape({}),
    label: PropTypes.shape({}),
    labelDisabled: PropTypes.shape({}),
    root: PropTypes.shape({}),
    tooltip: PropTypes.shape({}),
    tooltipContainer: PropTypes.shape({})
  })]),

  /** Custom tooltip message shown on cut/copy. */
  successText: PropTypes.string
};
CopyToClipboard.defaultProps = {
  action: 'copy',
  disabled: false,
  icon: faPaste,
  styleExtension: {
    button: {},
    buttonDisabled: {},
    buttonWrapper: {},
    clipContent: {},
    icon: {},
    iconDisabled: {},
    label: {},
    labelDisabled: {},
    root: {},
    tooltip: {},
    tooltipContainer: {}
  },
  successText: 'Copied!'
};
CopyToClipboard.displayName = 'CopyToClipboard';
export default CopyToClipboard;